import {Base} from "@/api/Base"

export class AttendanceList extends Base {
    path = "attendance/list"
}